import React, {useState} from 'react';
import {Box, Button, Collapse, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {DetailedCheckResponse} from '../../../../store/models/DuplicateCheck';
import {FIELD_LABELS} from './constants';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(2),
    },
}));

export default function ConfigPanel({config}: {config: DetailedCheckResponse['config']}) {
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);

    return (
        <Box className={classes.root}>
            <Button size="small" onClick={() => setExpanded((e) => !e)}>
                {expanded ? 'Konfiguration ausblenden' : 'Konfiguration anzeigen'}
            </Button>
            <Collapse in={expanded} timeout="auto">
                <Box mt={1} pl={1}>
                    <Typography variant="body2"><b>Gewichte</b></Typography>
                    {Object.entries(config.weights).map(([k, v]) => (
                        <Typography key={k} variant="body2">
                            {FIELD_LABELS[k] ?? k}: {Math.round(v * 100)} %
                        </Typography>
                    ))}
                    <Box mt={1}>
                        <Typography variant="body2"><b>Schwellwerte</b></Typography>
                        <Typography variant="body2">
                            Match: ≥ {Math.round(config.thresholds.match * 100)} %
                        </Typography>
                        <Typography variant="body2">
                            Unsicher: ≥ {Math.round(config.thresholds.uncertain * 100)} %
                        </Typography>
                    </Box>
                    {config.limits && (
                        <Box mt={1}>
                            <Typography variant="body2"><b>Grenzen</b></Typography>
                            <Typography variant="body2">
                                Max. Kandidaten (topN): {config.limits.maxTopN}
                            </Typography>
                            <Typography variant="body2">
                                Rate-Limit: max. {config.limits.rateLimit.maxRequests} Anfragen
                                / {config.limits.rateLimit.ttlSeconds}s
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Collapse>
        </Box>
    );
}
